import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Launched when the installed PWA opens its `start_url` (`/admin-cal/`).
 * Looks up the user's last-used token from localStorage and redirects to
 * /admin-cal/<token>. If no token is found, shows a friendly message.
 */
const AdminCalRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let token = null;
    try { token = localStorage.getItem('rgv_cal_last_token'); } catch (e) { /* noop */ }
    if (token) {
      navigate(`/admin-cal/${token}`, { replace: true });
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#1A1A2E] flex items-center justify-center p-6" data-testid="admin-cal-redirect">
      <div className="max-w-md text-center">
        <div className="bg-white/5 border border-white/10 rounded-2xl p-8">
          <h1 className="text-white text-xl font-bold mb-3">RGV Calendar</h1>
          <p className="text-white/70 text-sm mb-5">
            This installed app is linked to a personal access token. Open your
            calendar link (sent to you on WhatsApp) once from your browser to
            activate this app.
          </p>
          <p className="text-white/40 text-xs">
            Or contact the admin to receive a fresh calendar link.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminCalRedirect;
